export default "__VITE_ASSET__DZgSRZ5p__"